// extracted by mini-css-extract-plugin
export var quantityInput = "_fb-0";